import { gql } from '@apollo/client'

export const FileUploadNodeFragment = gql`
  fragment fileUploadNode on FileUploadNode {
    id
    name
    file
    s3Path
    hashSum
  }
`
